import { Helmet } from 'react-helmet-async';
import { Box, styled, Grid } from '@mui/material';
import { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import Breadcrumb from '../../../../components/Breadcrumb';
import { useDispatch, useSelector } from 'react-redux';
import { getSpecificUsersByRole } from '../../../../redux/actions/userActions';

import FormControlLabel from '@mui/material/FormControlLabel';
import Switch, { SwitchProps } from '@mui/material/Switch';

import {
  getAllFeatures,
  getSupplier
} from 'src/redux/actions/sysAdminActions';

import useFormControls from './SupplierTabs/SupplierInformation/Validations';
import '../../../../App.css';
import ExternalSupplierTable from './SupplierTabs/ExternalUsers/Table';
import SupplierInformation from './SupplierTabs/SupplierInformation/SupplierInformation';

import BasicCard from 'src/content/Dashboard/portalCard/card';

import BulkOrderChangeRequestConfig from './SupplierTabs/BulkOrderChangeRequestConfig';
import POReadyShipConfig from './SupplierTabs/ReadyShipConfig';

const MainContainer = styled(Box)(
  () => `
  padding: 32px 32px 0 32px;
  `
);

const CustomContainer = styled(Box)(
  () => `
  padding: 0px 0px 20px 0px;`
);

const ContentContainer = styled(Box)(
  () => `
  padding: 0px 31px 0px 31px;
  background-color:#FFFFFF;
  // overflow-y: auto;
  
  // height: 100vh !important;
  `
);

const SubContentContainer = styled(Box)(
  () => `
  padding: 24px 31px 0px 31px;
    background-color:#FFFFFF;
  `
);

const Header = styled(Box)(
  () => `
  font-family: 'OpenSans';
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  padding: 40px 0 16px 0;
  `
);

const TabItem = styled(Box)(
  () => `

  font-family: Open Sans;
  
  padding: 22px;
  cursor: pointer;
  color: #72869A;
  
font-weight: 700;
font-size: 18px;
  
height: 61px;
margin-right: 12px;

  
  `
);

const SubTabItem = styled(Box)(
  () => `

  font-family: Open Sans;
  padding: 12px 40px;
  cursor: pointer;
  color: #72869A;
  background: #F2F2F2;
border-radius: 3px 0px 0px 3px;
  
font-weight: 700;
font-size: 18px;
font-weight: 700;
font-size: 18px;
line-height: 21px;
  

  
  `
);

const TopBox = styled(Box)(
  () => `

 padding: 40px 32px 22px 32px;
 
 background: #FFFFFF
  
  `
);

const SupplierSetup = styled(Box)(
  () => `

font-weight: 700;
font-size: 16px;
line-height: 22px;
color: #343D42;
padding: 22px 0 32px 0;
font-family: 'OpenSans';

  `
);

/* identical to box height */

const CustomLabel = styled(FormControlLabel)(
  () => `
  margin: 0
  `
);

function EditSupplier() {
  const { state } = useLocation();

  const dispatch = useDispatch();
  const { id } = useParams();

  const supplierData = useSelector((state) => state?.suppliers?.supplierData);

  const [tab, setTab] = useState('Sup Info');
  const [subTab, setSubTab] = useState('Bulk PO Change Request');
  const [schedule, setSchedule] = useState();

  const [status, setStatus] = useState();

  const authToken = useSelector((state) => state?.auth?.token?.token);

  const authUserRole = useSelector((state) => state?.auth?.authUserData);

  useEffect(() => {
    if (id) {
    
      dispatch(getSupplier(id, authToken));
    }
    dispatch(getSpecificUsersByRole('ROLE_BUYER', 'A', authToken));
    dispatch(getAllFeatures(authToken));
  }, [id]);


  const IOSSwitch = styled((props) => (
    <Switch
      focusVisibleClassName=".Mui-focusVisible"
      disableRipple
      {...props}
    />
  ))(({ theme }) => ({
    width: 42,
    height: 26,
    padding: 0,
    '& .MuiSwitch-switchBase': {
      padding: 0,
      margin: 2,
      transitionDuration: '300ms',
      '&.Mui-checked': {
        transform: 'translateX(16px)',
        color: '#fff',
        '& + .MuiSwitch-track': {
          backgroundColor:
            theme.palette.mode === 'light' ? '#2ECA45' : '#65C466',
          opacity: 1,
          border: 0
        },
        '&.Mui-disabled + .MuiSwitch-track': {
          opacity: 0.5
        }
      },
      '&.Mui-focusVisible .MuiSwitch-thumb': {
        color: '#33cf4d',
        border: '6px solid #fff'
      },
      '&.Mui-disabled .MuiSwitch-thumb': {
        color:
          theme.palette.mode === 'light'
            ? theme.palette.grey[100]
            : theme.palette.grey[600]
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: theme.palette.mode === 'light' ? 0.7 : 0.3
      }
    },
    '& .MuiSwitch-thumb': {
      backgroundColor: '#ffffff !important',
      boxSizing: 'border-box',
      width: 22,
      height: 22
    },
    '& .MuiSwitch-track': {
      borderRadius: 26 / 2,
      backgroundColor: theme.palette.mode === 'light' ? '#E9E9EA' : '#39393D',
      opacity: 1,
      transition: theme.transitions.create(['background-color'], {
        duration: 500
      })
    }
  }));

  const { handleInputValue, handleFormSubmit, formIsValid, errors } =
    useFormControls(undefined, status);

  return (
    <>
      <MainContainer>
        <CustomContainer>
          {state && state?.breadCrumb === 'manage-sales-suppliers' ? (
            <Breadcrumb
              userData={supplierData}
              location={[
                { location: 'Manage Supplier', to: '/manage-suppliers' }
              ]}
            />
          ) : (
            <Breadcrumb
              userData={supplierData}
              location={[
                { location: 'Manage Supplier', to: '/manage-suppliers' }
              ]}
            />
          )}

          <SupplierSetup>
            <span>Supplier Setup</span>
          </SupplierSetup>

          <CustomContainer>
            <Grid
              container
              rowSpacing={1}
              columnSpacing={{ xs: 0, sm: 0, md: 0 }}
              sx={{ padding: '10px 0 0 0px' }}
            >
              {/* <Grid item xs={12} md={12}> */}
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'flex-start',
                  textAlign: 'center',
                  flexWrap: 'wrap'
                }}
              >
                <TabItem
                  className={`TEST` && tab === 'Sup Info' && 'tabActive'}
                  id="TEST"
                  onClick={() => setTab('Sup Info')}
                >
                  Supplier Information
                </TabItem>

                {authUserRole &&
                  authUserRole?.roles?.find(
                    (d) =>
                      (d?.code === 'ROLE_SUPER_ADMIN' ||
                        d?.code === 'ROLE_SYSTEM_ADMIN')
                  ) && (
                    <TabItem
                      className={`TEST2` && tab === 'Ext User' && 'tabActive'}
                      id="TEST2"
                      onClick={() => setTab('Ext User')}
                    >
                      External User(s)
                    </TabItem>
                  )}

                  <TabItem
                    className={`TEST4` && tab === 'Config' && 'tabActive'}
                    id="TEST4"
                    onClick={() => setTab('Config')}
                  >
                    Configuration
                  </TabItem>
              </Box>
            </Grid>
            <Grid item md={12} xs={12}>
              {tab && tab === 'Sup Info' && (
                <ContentContainer>
                  <SupplierInformation scheduleData={schedule} />
                </ContentContainer>
              )}

              {tab && tab === 'Ext User' && (
                <>
                  <ExternalSupplierTable />
                </>
              )}

              {tab && tab === 'Int User' && (
                <>
                  <Box
                    sx={{
                      background: '#F7F7F7',
                      padding: '30px'
                    }}
                  >
                    {' '}
                    <Box
                      sx={{
                        display: { md: 'flex', xs: 'box' },
                        flexDirection: 'row'
                      }}
                    >
                      <Box sx={{ flexGrow: 1 }}>
                        <span style={{ fontWeight: '700', fontSize: '20px' }}>
                          Internal User(s)
                        </span>
                      </Box>
                    </Box>
                  </Box>
                </>
              )}

              {tab && tab === 'Config' && (
                <SubContentContainer>
                  <CustomContainer>
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'flex-start',
                        textAlign: 'center',
                        flexWrap: 'wrap'
                      }}
                    >
                      <SubTabItem
                        className={
                          `TEST4` &&
                          subTab === 'Bulk PO Change Request' &&
                          'subTabActive'
                        }
                        id="TEST4"
                        onClick={() => setSubTab('Bulk PO Change Request')}
                      >
                        Order Change Request
                      </SubTabItem>
                      <SubTabItem
                        className={
                          `TEST4` &&
                          subTab === 'Ready Ship' &&
                          'subTabActive'
                        }
                        id="TEST4"
                        onClick={() => setSubTab('Ready Ship')}
                      >
                        Ready Ship
                      </SubTabItem>
                    </Box>
                    {subTab && subTab === 'Bulk PO Change Request' && (
                      <>
                        <BulkOrderChangeRequestConfig />
                      </>
                    )}
                    {subTab && subTab === 'Ready Ship' && (
                      <>
                        <POReadyShipConfig />
                      </>
                    )}
                  </CustomContainer>
                </SubContentContainer>
              )}

            </Grid>
          </CustomContainer>
        </CustomContainer>
      </MainContainer>
    </>
  );
}

export default EditSupplier;
